import { render, staticRenderFns } from "./maintain.vue?vue&type=template&id=5dd85ab2&scoped=true&"
import script from "./maintain.vue?vue&type=script&lang=js&"
export * from "./maintain.vue?vue&type=script&lang=js&"
import style0 from "./maintain.vue?vue&type=style&index=0&id=5dd85ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd85ab2",
  null
  
)

export default component.exports